import ProductPage from "../components/pages/products/ProductPage";
import ProductDetailsPage from "../components/pages/products/ProductDetailsPage";
import ProductMetricsPage from "../components/pages/products/ProductMetricsPage";
import SalesStockPage from "../components/pages/products/SalesStockPage";
import POSExportPage from "../components/pages/products/POSExportPage";
import MyDefaultSeasonsPage from "../components/pages/products/myDefaultsPages/MyDefaultSeasonsPage";
import MyDefaultGendersPage from "../components/pages/products/myDefaultsPages/MyDefaultGendersPage";
import MyDefaultSizesPage from "../components/pages/products/myDefaultsPages/MyDefaultSizesPage";
import MyDefaultColorsPage from "../components/pages/products/myDefaultsPages/MyDefaultColorsPage";
import MyDefaultCategsPage from "../components/pages/products/myDefaultsPages/MyDefaultCategsPage";

const routes = [
    {
        path: "/products",
        element: <ProductPage />
    },
    {
        path: "/products/details",
        element: <ProductDetailsPage />
    },
    {
        path: "/products/metrics",
        element: <ProductMetricsPage />
    },
    {
        path: "/products/metrics/:id",
        element: <ProductMetricsPage />
    },
    {
        path: "/products/stock",
        element: <SalesStockPage />
    },
    {
        path: "/products/pos-export",
        element: <POSExportPage />
    },
    {
        path: "/products/my-defaults/seasons",
        element: <MyDefaultSeasonsPage />
    },
    {
        path: "/products/my-defaults/genders",
        element: <MyDefaultGendersPage />
    },
    {
        path: "/products/my-defaults/sizes",
        element: <MyDefaultSizesPage />
    },
    {
        path: "/products/my-defaults/colors",
        element: <MyDefaultColorsPage />
    },
    {
        path: "/products/my-defaults/categories",
        element: <MyDefaultCategsPage />
    }
];

export default routes;
